import * as React from 'react';

import { Button, ButtonType, Row, Space, Text } from 'farmhub-ui-core';
import { Link } from 'react-router-dom';

import { AddOutlineIcon } from 'components/Icon';
import { theme } from 'styled';

import { Wrapper } from './styles';

interface PageTitleBarProps {
  title?: string | React.ReactNode;
  url?: any;
  extraAction?: any;
  padding?: number;
  logo?: JSX.Element;
  background?: string;
  radius?: string;
  breadcrumb?: React.ReactNode;
  isCreateButtonHidden?: boolean;
  extraActionSide?: 'left' | 'right';
}

const PageTitleBar = ({
  title,
  url,
  extraAction,
  padding,
  logo,
  background,
  radius,
  breadcrumb,
  isCreateButtonHidden = false,
  extraActionSide = 'right',
}: PageTitleBarProps): JSX.Element => (
  <Wrapper background={background} padding={padding} radius={radius}>
    <Row>
      {logo}
      {logo && <Space width={24} />}
      {breadcrumb}
      {typeof title === 'string' ? (
        <Text
          lineHeight="auto"
          size="sm"
          textTransform="uppercase"
          weight="extraBold"
        >
          {title}
        </Text>
      ) : (
        title
      )}
    </Row>
    <Row styles={{ gap: 0 }} width="fit-content">
      {extraActionSide === 'left' && extraAction}
      {extraActionSide === 'right' && extraAction}
      {url && !isCreateButtonHidden ? (
        <Link to={url}>
          <Button
            height={theme.button.height.sm}
            icon={{ children: <AddOutlineIcon height={16} width={16} /> }}
            type={ButtonType.Text}
          >
            Thêm mới
          </Button>
        </Link>
      ) : null}
    </Row>
  </Wrapper>
);

export default PageTitleBar;
